import { Injectable } from "@angular/core";
import * as moment from "moment";

@Injectable()
export class DateParserService {
    public readonly caseOne = /^(\d{1,6})( \d{1,6})?$/; // string starts with 6 numbers, optionally followed by a space followed by one or more (max 6) numbers
    public readonly caseTwo = /^((\d\d?)[-.](\d\d?)[-.](\d\d))( \d{1,6})?$/;

    public parseDate(inputString : string) {
        var datePart ; 
        var timePart; 
        switch(true) {
            case this.caseOne.test(inputString): 
                var params = this.caseOne.exec(inputString); 
                datePart = this.parseDatePart(params[1]); 
                timePart = this.parseTimePart(params[2]);
                break;
            case this.caseTwo.test(inputString): 
                var params2 = inputString.replace(this.caseTwo,"$2 $3 $4$5").split(" ");
                datePart = this.parseDatePart(params2[0] + this.leftPadWhenUnevenDigits(params2[1]) + this.leftPadWhenUnevenDigits(params2[2]));
                timePart = this.parseTimePart(params2[3]);
                break;
            default: 
                var lastResort = moment(inputString , "DD-MM-YYYY HH:mm:ss");
                if(! lastResort.isValid()) {
                    return inputString;
                }
                return lastResort;
            }
        var returnValue = moment(datePart + ' ' + timePart , "DD-MM-YYYY HH:mm:ss");
        if(!returnValue.isValid()) {
            return inputString ; 
        }
        return returnValue;
    }
    public parseDatePart(datePart: string) {
        datePart = this.leftPadWhenUnevenDigits(datePart); 
        var currentDate = moment(); 
        var day ; var month ; var year ; 

        day = datePart.slice(0,2); 

        if(datePart.length >= 4) {
            month = datePart.slice(2,4);
        } else {
            month = this.leftPadWhenUnevenDigits((currentDate.month() + 1).toString());
        }

        if(datePart.length >= 6)
        {
            year = '20' + datePart.slice(4,6); 
        } else {
            year = currentDate.year(); 
        }
        return day + '-' + month + '-' + year; 
    }

 parseTimePart(timePart) {
        if (timePart == undefined) {
            return '00:00:00';
        }

        timePart = timePart.trim();
        timePart = this.leftPadWhenUnevenDigits(timePart);
        if (timePart.length == 2) { // minutes should also be defined
            timePart = timePart + '00';
        }

        return this.formatTuples(timePart, ':');
    }


    public leftPadWhenUnevenDigits(stringToPad) {
        if(stringToPad.length % 2) {
            return '0' + stringToPad; 
        }
        return stringToPad;
    }

    public formatTuples(stringToFormat : string,delimiter) {
        var returnValue = ''; 
        while(stringToFormat.length > 0)
        {
            returnValue = returnValue + stringToFormat.slice(0,2) + ':';
            stringToFormat = stringToFormat.slice(2,stringToFormat.length);
        }

        if(delimiter !== '') {
            return returnValue.slice(0,returnValue.length -1); 
        }

        return returnValue;
    }
}